import React from 'react';

const ExchangeProblem = () => {
  return (
    <section className="py-20 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
          Training That Keeps Pace
        </h2>
        
        <p className="text-2xl md:text-3xl font-bold text-cyan-400 mb-8">
          Onboarding isn't enough.
        </p>
        
        <p className="text-xl text-gray-300 mb-6 leading-relaxed">
          Roles change. Expectations rise. Skills evolve.
        </p>
        
        <p className="text-xl text-gray-300 leading-relaxed">
          Traain Exchange gives enterprise teams ongoing access to high-quality Training — without rebuilding content from scratch.
        </p>
      </div>
    </section>
  );
};

export default ExchangeProblem;
